<template>


  <v-fab-transition>
    <v-card
        class=""
        width="508"
        v-show="active"
        height="630"
        transparent
        flat
        elevation="20"
        color="#508fcc"
        style="margin-top:40px;margin-left:40px;"
    >
      <v-system-bar
          style="position: absolute;z-index: 2;width:100%;height:40px;background: rgba(0,0,0,0.0)"

          dark
      >
        <h4 :style="{'color':(stage<2 || stage===7)?'#508fcc':'white'}" style="width:100%;text-align: center;font-weight: bold;">Sponsrat meddelande från HPGuiden</h4>
      </v-system-bar>
      <v-fade-transition>
      <v-img
          v-show="stage<2 || stage===7"

          style="position: absolute; top: 0px; left: 0px; width: 511px; margin-left: -2px; border-top-left-radius: 4px;border-top-right-radius: 4px;max-width:200% !important;z-index: 0;"
          :src="'https://hihat.io/api/images/hpframe2.png'"
      ></v-img>
      </v-fade-transition>


      <v-fab-transition>
      <v-img
          v-show="stage<2 || stage===7"
          style="left:151px;top:80px;"
          height="200"
          width="200"
        :src="'https://hihat.io/api/images/hpguiden2.png'"
      >
      </v-img>
      </v-fab-transition>
      <v-fab-transition>
        <v-img
            class="glow22"
            v-show="stage>1 && stage<6"
            style="height: 100px; width: 100px; left: 201px; top: 31px; position: absolute; transform-origin: center center; z-index: 1; "
            height="100"
            width="100"
            :src="'https://hihat.io/api/images/hpguiden2.png'"
        >
        </v-img>
      </v-fab-transition>
      <v-slide-y-transition>
        <v-card flat color="transparent" style="height:200px;width:100%;top:350px;position: absolute;" v-show="stage===1">

          <v-card-text>
            <h1 style="margin-top:40px;width:100%;text-align: center;color:white;line-height:40px;font-family: 'DIN';font-size:38px;">
              Bli expert på högskoleprovet <br> och  nå din drömutbildning
            </h1>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>
      <v-slide-y-transition>
        <v-card flat color="transparent" style="height:200px;width:100%;top:350px;position: absolute;" v-show="stage===7">

          <v-card-text>
            <h1 style="width:100%;text-align: center;color:white;font-family: 'DIN';line-height: 40px;font-size:34px;">
              Vi hjälper dig nå din drömutbildning.<br> Bli VIP-medlem redan idag!
            </h1>
            <h3 style="margin-top:14px;width:100%;text-align: center;color:white;font-family: 'DIN';font-size:24px;">
              Kolla länk i chatten för erbjudande
            </h3>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>


      <v-slide-y-transition>


      <v-img
          v-show="stage>=3 & stage<=5"
          style="position:absolute;top:80px;left:0;"
          height="508"
          width="630"
          :src="'https://hihat.io/api/images/hpframe3.png'"
      >
        <v-fade-transition>
        <v-row v-if="stage===3" style="height:100%;width:100%;">
          <v-col  style="margin-top:40px;font-size:16px;margin-bottom:-40px;" align="center" cols="12">
            <h2>Vad betyder <br> <i>{{word_selected.word}}</i> ?</h2>

          </v-col>
            <v-col   cols="12"
                   v-for="(word,index) in word_selected.alt"
                   :key="index"


            >
              <h3  style="margin-left:40px;display:flex;white-space: nowrap;"><v-chip style="font-size:20px;margin-right:4px;border-top-left-radius: 0;" dark color="#508fcc" >!{{['A ','B ','C ','D ','E '][index]}}</v-chip>{{word}}<v-spacer></v-spacer> <v-chip  >{{votes[index].length}}</v-chip> </h3>

            </v-col>


        </v-row>

        </v-fade-transition>
        <v-fade-transition>
          <v-row v-if="stage===5" style="height:100%;width:100%;">
            <v-col  style="margin-top:40px;font-size:16px;margin-bottom:-40px;" align="center" cols="12">
              <h2><i>{{word_selected.word}}</i> betyder <br>{{word_selected.correct}}</h2>

            </v-col>
            <v-col  style="margin-top:40px;font-size:16px;margin-bottom:-40px;padding: 30px;" align="center" cols="12">

              <h4 style="width:100%;text-align: center;">GG WP</h4>

            </v-col>
            <v-col  style="margin-top:0;font-size:16px;margin-bottom:-40px;padding: 30px;" align="center" cols="12">
              <v-chip dark color="red" :key="index"  v-for="(voter,index) in votes[correct_index]"  >

                {{voter}}
              </v-chip>

            </v-col>



          </v-row>

        </v-fade-transition>

        <div v-show="stage===3"  id="add_names" style="width:100%;height:100%;background: transparent;position: absolute;top:0;left:0;op">

        </div>


      </v-img>
        </v-slide-y-transition>









    </v-card>
  </v-fab-transition>


</template>

<script>
export default {
  name: "SponsHP",
  data() {
    return {
      active:false,
      stage:0,
      correct_index:0,

      words:[
        {
          correct:"kort berättelse",
          alt:[
            "gissning",
            "diskret gest",
            "noggrann redogörelse",
            "kort berättelse",
            "motsättning"
          ],
          word:"anekdot"

        },
        {
          correct:"anmärka på",
          alt:[
            "prata om",
            "intyga",
            "märka ut",
            "återvinna",
            "anmärka på"
          ],
          word:"reklamera"

        },
        {
          correct:"betydligt",
          alt:[
            "ganska",
            "korrekt",
            "betydligt",
            "välriktat",
            "fullständigt"
          ],
          word:"avsevärt"

        },
        {
          correct:"stor resväska",
          alt:[
            "sybord",
            "lång rock",
            "lastpall",
            "klädförråd",
            "stor resväska"
          ],
          word:"koffert"

        },
        {
          correct:"utländsk",
          alt:[
            "utländsk",
            "inbyggd",
            "salongmässig",
            "lismande",
            "sjuklig"
          ],
          word:"exotisk"

        },
        {
          correct:"speja",
          alt:[
            "omskriva",
            "utvecklas negativt",
            "samla ihop",
            "roa sig",
            "speja"
          ],
          word:"rekognosera"

        },
        {
          correct:"rapportera",
          alt:[
            "samtycka",
            "rapportera",
            "nyansera",
            "oxidera metall",
            "förändra"
          ],
          word:"anmäla"

        },
        {
          correct:"konstpremiär",
          alt:[
            "upptrappning",
            "odlingsbarplats i öknen",
            "skicklighet",
            "konstpremiär",
            "stöldmani"
          ],
          word:"vernissage"

        },
        {
          correct:"inställa",
          alt:[
            "avsäga sig arv",
            "inställa",
            "granska",
            "orka",
            "församlas"
          ],
          word:"postponera"

        },
        {
          correct:"omkasta",
          alt:[
            "hyckla",
            "kräkas",
            "segla med aktervind",
            "stoltsera",
            "omkasta"
          ],
          word:"invertera"

        },
        {
          correct:"vristplagg",
          alt:[
            "gå till fots",
            "fan",
            "vristplagg",
            "teaterstycke",
            "kollektivjordbruk"
          ],
          word:"damask"

        },
        {
          correct:"äckla",
          alt:[
            "äckla",
            "välva",
            "undersöka växter",
            "förändra",
            "hindra"
          ],
          word:"kvälja"

        },
        {
          correct:"uppsuga",
          alt:[
            "argumentera för",
            "uppsuga",
            "vira om",
            "anpassa till dator",
            "erfara"
          ],
          word:"resorbera"

        },
        {
          correct:"varg",
          alt:[
            "varg",
            "upptrappning",
            "brottslig handling",
            "mastkorg",
            "självlärd"
          ],
          word:"gråben"

        },
        {
          correct:"sömnlöshet",
          alt:[
            "avgörande",
            "sömnlöshet",
            "fåordig",
            "hånfull",
            "förtorkad"
          ],
          word:"insomnia"

        },
        {
          correct:"avtal",
          alt:[
            "melodiutsmyckning",
            "lärjunge",
            "avtal",
            "osjälviskhet",
            "portion"
          ],
          word:"pakt"

        },
        {
          correct:"ingyggd balkong",
          alt:[
            "skulderparti",
            "nattläger",
            "bokstavsförbindelse",
            "inbyggd balkong",
            "dyrbarhet"
          ],
          word:"burspråk"

        },
        {
          correct:"obalanserad",
          alt:[
            "ståtlig",
            "omoralisk",
            "plågsam",
            "obalanserad",
            "motsträvig"
          ],
          word:"lynnig"

        },
        {
          correct:"veckad",
          alt:[
            "veckad",
            "som utförs för hand",
            "banal",
            "strängt undersökande",
            "blyg"
          ],
          word:"korrugerad"

        },
        {
          correct:"enhetlig",
          alt:[
            "prydlig",
            "väderbiten",
            "enhetlig",
            "obebodd",
            "i tidsföljd"
          ],
          word:"homogen"

        },
        {
          correct:"duglig",
          alt:[
            "duglig",
            "behärskad",
            "undermålig",
            "snitsig",
            "förslagen"
          ],
          word:"kompetent"

        },
        {
          correct:"komplexfylld",
          alt:[
            "bestämd",
            "kaosartad",
            "krass",
            "flyktig",
            "komplexfylld"
          ],
          word:"hämmad"

        },
        {
          correct:"utse kandidat",
          alt:[
            "utse kandidat",
            "glädja",
            "fastgöra",
            "ge från hand till hand",
            "ha starkt intresse för"
          ],
          word:"nominera"

        },
        {
          correct:"träna på varandra",
          alt:[
            "komma på",
            "träna på varandra",
            "nära",
            "slamma upp",
            "intrigera"
          ],
          word:"sparra"

        },
        {
          correct:"hälsena",
          alt:[
            "ekonomisk kalkyl",
            "hälsena",
            "förknippning",
            "huvudväg",
            "versal"
          ],
          word:"akillessena"

        },
        {
          correct:"upphetsad",
          alt:[
            "käck",
            "obefogad",
            "upphetsad",
            "ömsesidig",
            "människoliknande"
          ],
          word:"exalterad"

        },
        {
          correct:"lik",
          alt:[
            "lik",
            "överhetsperson",
            "konstbefruktning",
            "kliché",
            "uttal"
          ],
          word:"kadaver"

        },
        {
          correct:"självplågare",
          alt:[
            "ragg",
            "kort historia",
            "underlåtenhet",
            "överflödiga ord",
            "självplågare"
          ],
          word:"fakir"

        },
        {
          correct:"surmulen",
          alt:[
            "samhällsbevarande",
            "surmulen",
            "inbyggd",
            "hårdhjärtad",
            "påverkad"
          ],
          word:"purken"

        },
        {
          correct:"liten båt",
          alt:[
            "orkestermedlem",
            "utgivning",
            "liten båt",
            "gräns",
            "fält"
          ],
          word:"snipa"

        },
        {
          correct:"hämta",
          alt:[
            "avse",
            "brännmärka",
            "brusa",
            "mångfaldiga",
            "hämta"
          ],
          word:"apportera"

        },
        {
          correct:"alldaglig",
          alt:[
            "moraliskt fördärvad",
            "alldaglig",
            "ynklig",
            "lång och smal",
            "urvattnad"
          ],
          word:"banal"

        }
      ],
      word_selected: {
        word:"",
        correct:"",
        alt:[]
      },
      votes:[
        [],
        [],
        [],
        [],
        []
      ]



    }
  },
  mounted:function(){
    let u=this.$route.query.u;
    this.$socket.emit('spons_listen_hp',u);












  },

  computed: {


  },

  sockets: {

    on_vote:function(data){
      this.vote({name:data.name,vote:data.vote})
    },

    show_hp:function(){
      let self=this;
      this.word_selected=this.words[Math.floor(Math.random()*this.words.length)];
      this.correct_index=this.word_selected.alt.indexOf(this.word_selected.correct);

      this.active=true;

      setTimeout(function(){
        self.stage=1;
      },1000)
      setTimeout(function(){
        self.stage=2;
      },4000)
      setTimeout(function(){
        self.stage=3;
      },4500)
      setTimeout(function(){
      },5500)
      setTimeout(function(){
        self.stage=4;
      },36500)
      setTimeout(function(){
        self.stage=5;
      },37000)
      setTimeout(function(){
        self.stage=6;
      },43000)
      setTimeout(function(){
        self.stage=7;
        self.$socket.emit('bye_spons_hp',self.votes[0].length+self.votes[1].length+self.votes[2].length+self.votes[3].length+self.votes[4].length);

      },43500)
      setTimeout(function(){
        self.active=false;
        self.votes=[
          [],
          [],
          [],
          [],
          []
        ]

      },48500)
    }

  },
  methods:{

    vote:function(vote_data){
      let command_to_index={
        "!a":0,
        "!b":1,
        "!c":2,
        "!d":3,
        "!e":4
      }
      let vote_index=command_to_index[vote_data.vote.toLowerCase()];
      this.votes[vote_index].push(vote_data.name)
      let element=document.createElement("div");


      element.innerHTML=`<span id="${vote_data.name}" class="v-chip theme--dark v-size--default red fade_left" style="position:absolute;top:${130+(79*vote_index)}px;left:410px;"><span class="v-chip__content">${vote_data.name}</span></span>`
      document.getElementById("add_names").appendChild(element.firstChild);
      setTimeout(function(){
        document.getElementById("add_names").removeChild(document.getElementById(vote_data.name));
      },3*1000)

    },

    generate_fake_votes:function(){
      let fake_names=[
        "2cuteilla",
        "Actuallynner",
        "Americast",
        "AmyKrool",
        "Artuggle",
        "Asedayal",
        "Barqualin",
        "Bazartip",
        "Blondeange",
        "Boardfi",
        "Boardintech",
        "Calcite",
        "Candyes",
        "Cattapp",
        "ChickEssence",
        "Comfylk",
        "Confire",
        "Coniervo",
        "Contreelo",
        "Cottonor",
        "Cyberlo",
        "Desightit",
        "Dictatorma",
        "DiddyParis",
        "Disseri",
        "Exterolo",
        "Fabrium",
        "Fareo",
        "FelineFaith",
        "Flexisys",
        "FluentGrabs",
        "Fraserstru",
        "FullyWet",
        "GazetteExclusive",
        "Givelz",
        "GrimSun",
        "GrimWitch",
        "Gurlyco",
        "HeadDev",
        "HeheMoto",
        "HeheRob",
        "Hipbb",
        "Huningst",
        "InfernoKix",
        "Integar",
        "Islandella",
        "JimMj",
        "JoFinest",
        "KenkaMega",
        "Laoandr",
        "LeonHead",
        "Listin",
        "Losimuni",
        "Lummobe",
        "Mcanardua",
        "Mcel",
        "Midnighter",
        "MinyTinnys",
        "Mohawkey",
        "NessNaybor",
        "NoticeSaiyan",
        "NycBleak",
        "Papass",
        "Pellinkie",
        "PerfectHippo",
        "Persdant",
        "Phiard",
        "PiraAsta",
        "Racer2cool",
        "RadioThesoy",
        "Relysi",
        "RocketSister",
        "Ryothus",
        "Sablinkak",
        "Sageolag",
        "Sanlc",
        "Scirraybo",
        "SelfCuddly",
        "Senaouder",
        "SereneKeepup",
        "SkierSnoop",
        "Sonflina",
        "Spiceelli",
        "Spicernin",
        "Sublega",
        "TalentCharms",
        "TalesStylish",
        "TaruRocker",
        "Theevilla",
        "TigerMusic",
        "ToyFlavored",
        "TrendyShoes",
        "TrustQuayle",
        "Ttiendos",
        "Twiter",
        "Tyob",
        "V2co",
        "Vamim",
        "Venabba",
        "Verterma"
      ];
      let name=fake_names[Math.floor(Math.random()*fake_names.length)]
      var vote0 =["!A","!B","!C","!D","!E"][Math.floor(Math.random()*5)]
      this.vote({name:name,vote:vote0});
      let self=this;
      setTimeout(function(){
        if(self.stage===3){
          self.generate_fake_votes();
        }
      },750+(Math.random()*500))
    },
  }
}
</script>

<style>
@font-face {
  font-family: "DIN";
  src: url(https://hihat.io/api/images/DIN_CondensedBold.ttf) format("truetype");
}

.shadowed{
  color: rgb(163,163,163);
}
iframe{
  width:100% !important;
  height:100% !important;
}

@keyframes MOVE-BG {

  from {
    -webkit-transform: translateX(-200px);
    -moz-transform: translateX(-200px);
    -ms-transform: translateX(-200px);
    -o-transform: translateX(-200px);
    transform: translateX(-200px);

  }
  to {

    -webkit-transform: translateX(-350px);
    -moz-transform: translateX(-350px);
    -ms-transform: translateX(-350px);
    -o-transform: translateX(-350px);
    transform: translateX(-350px);

  }
}
.move_bg{
  animation-name: MOVE-BG;
  animation-duration: 30s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
}

.hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 2s, opacity 2s linear;
}
.visible {
  visibility: visible;
  opacity: 1;
}

.shake_me{
  animation: recolor 0.3s infinite;
}

.fade_left{
  animation: fade-left 3s;
}

@keyframes fade-left {
  0% { transform:  translate(0, 0) rotate(0deg); }
  100% { transform:  translate(-200px, 0) rotate(10deg);opacity:0; }

}





@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

@keyframes zoom {
  0% { : scale(1,1); }

  50% { transform: scale(1,1.4);}

  100% { transform: scale(1,1); }
}

@keyframes recolor {
  0% { background: rgba(0, 0, 0, 0.0); }

  50% { background: rgba(45, 83, 229, 0.1);}

  100% { background: rgba(0, 0, 0, 0.0);  }
}

.glow22{
  -webkit-filter: drop-shadow(3px 3px 3px #cd9eff);
  animation:glowy22 2s infinite;
}

@keyframes glowy22 {
  0% { -webkit-filter: drop-shadow(0px 0px 3px #ffffff); }
  50% { -webkit-filter: drop-shadow(0px 15px 9px #ffffff);}
  100% { -webkit-filter: drop-shadow(0px 0px 3px #ffffff); }


}


</style>
